import { isEmpty, isNil } from "lodash";
import { Typography } from "PFComponents/typography";
import { MatchedActivity } from "PFTypes";
import React from "react";
import { useTranslation } from "react-i18next";

import { Section } from "../../components";
import css from "./interest_questions_section.module.scss";

type InterestQuestionsSectionProps = {
  role: MatchedActivity["activity"];
};

export const InterestQuestionsSection = ({ role }: InterestQuestionsSectionProps): JSX.Element | null => {
  const { t } = useTranslation(["marketplace", "translation"]);

  const interestQuestions = role.metadata.interest_questions;
  const interestDetails = role.interest_details;
  const answers = [interestDetails?.answer1, interestDetails?.answer2, interestDetails?.answer3];

  if (isEmpty(interestQuestions)) {
    return null;
  }

  return (
    <Section title={t("marketplace:workOpportunities.roleDetails.interestQuestions.title")}>
      {interestQuestions?.map((question, index) => (
        <React.Fragment key={index}>
          <Typography variant="bodyRegular" className={css.questionContent} noMargin>
            {question}
          </Typography>
          {!isNil(answers[index]) && (
            <Typography variant="bodyRegular" noMargin>
              {answers[index] ? t("translation:yes") : t("translation:no")}
            </Typography>
          )}
        </React.Fragment>
      ))}
    </Section>
  );
};
